/**
 * Takes a string and format it into bank account
 * @param {string} The string to split
 * @returns {string} The formatted string
 */
export default function bankAccountNumberFilter(input: string): string {
  // if the input doesn't match a bank account with a
  // 2 or 3 digit suffix just return the initial input
  if (!input || input.length > 16 || input.length < 15) {
    return input;
  }
  const bankNumber = input.slice(0, 2);
  const branchNumber = input.slice(2, 6);
  const accountNumber = input.slice(6, 13);
  let suffix = input.slice(13);

  if (suffix.length < 3) {
    suffix = suffix.padStart(3, "0");
  }

  return [bankNumber, branchNumber, accountNumber, suffix].join("-");
}
